import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { SERVICE_NAME as SYSTEM_SERVICE_NAME, SystemService, $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { MeterService, METER_SERVICE_NAME } from '../../../services/meter'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'
import { SchemaService, SCHEMA_SERVICE_NAME } from '../../../services/schema'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { MeterDetailsDirectiveController } from './meters-details.directive.controller'

//#region Asset Imports

import './meters-details.scss'
import * as TEMPLATE from './meters-details.tpl.html'

//#endregion

// Setup

export class MeterDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        'logger',
        $TIMEOUT_SERVICE_NAME,
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        METER_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        SCHEMA_SERVICE_NAME,
        GRID_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            logger: LoggerService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            systemService: SystemService,
            meterService: MeterService,
            deviceService: DeviceService,
            schemaService: SchemaService,
            gridService: GridService
        ) => new MeterDetailsDirectiveController(
            $scope,
            $q,
            logger,
            $timeout,
            localDictionary,
            userSession,
            systemService,
            meterService,
            deviceService,
            schemaService,
            gridService,
            MeterService.REFERENCE_TYPE,
            MeterService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE

    // Setup End
}